import { createBrowserRouter, Navigate } from 'react-router-dom';
import RootLayout from './components/RootLayout';
import WizardShell from './components/wizard/WizardShell';
import {
  AdvisorPrequalificationPage,
  AmbassadorPrequalificationPage,
} from './pages/RecruitmentPrequalificationPage';
import { CTOApplicationPage, GTMApplicationPage } from './pages/InternalHirePrequalPage';
import { CLIENT_STEPS, TALENT_STEPS, PARTNER_STEPS } from './components/wizard/steps';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    children: [
      { index: true, element: <WizardShell /> },
      { path: 'route', Component: WizardShell },

      // ─── Advisor & Ambassador prequalification (no wizard, standalone) ─
      { path: 'advisor',    element: <AdvisorPrequalificationPage /> },
      { path: 'ambassador', element: <AmbassadorPrequalificationPage /> },

      // ─── Internal hire ARIA prequal (CTO / GTM) ──────────
      { path: 'hiring/cto',    element: <CTOApplicationPage /> },
      { path: 'hiring/gtm',    element: <GTMApplicationPage /> },

      // ─── CLIENT × 8 steps ────────────────────────────────
      ...CLIENT_STEPS.map((s) => ({
        path: `client/${s.slug}`,
        element: <WizardShell persona="client" step={s.slug} />,
      })),

      // ─── TALENT × 7 steps ────────────────────────────────
      ...TALENT_STEPS.map((s) => ({
        path: `talent/${s.slug}`,
        element: <WizardShell persona="talent" step={s.slug} />,
      })),

      // ─── PARTNER × 5 steps ───────────────────────────────
      ...PARTNER_STEPS.map((s) => ({
        path: `partner/${s.slug}`,
        element: <WizardShell persona="partner" step={s.slug} />,
      })),

      { path: '*', element: <Navigate to="/route" replace /> },
    ],
  },
]);
